import { render } from "./EmployeeCreateComponent.vue?vue&type=template&id=6795fc6e"
import script from "./EmployeeCreateComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/employees/EmployeeCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6795fc6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6795fc6e', __exports__)) {
    api.reload('6795fc6e', __exports__)
  }
  
  module.hot.accept("./EmployeeCreateComponent.vue?vue&type=template&id=6795fc6e", () => {
    api.rerender('6795fc6e', render)
  })

}


export default __exports__